// dependencies
import { matchSorter } from "match-sorter";

export function matchSorterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue, { keys: [(row) => row.values[id]] });
}

export const sortItems = (prev: Row, curr: Row, columnId: string) => {
	if (prev.original[columnId].toLowerCase() > curr.original[columnId].toLowerCase()) {
		return 1;
	} else if (prev.original[columnId].toLowerCase() < curr.original[columnId].toLowerCase()) {
		return -1;
	} else {
		return 0;
	}
};